<ng-container *ngIf="visible() && guide.activeVariant() as v">
  <div
    class="vd-gb"
    [class.hovering]="hovering()"
    [class.expanded]="expanded()"
    [class.rtl]="guide.isRtl()"
    (mouseenter)="onEnter()"
    (mouseleave)="onLeave()"
    (click)="onCardClick()"
    role="button"
    tabindex="0"
    (keydown.enter)="openModal()"
    [attr.aria-label]="('guide.open_aria' | transloco) + ' — ' + v.title"
  >
    <span class="vd-gb-pulse" *ngIf="!guide.activeSeen()"></span>

    <div class="vd-gb-media">
      <video
        #previewVideo
        [poster]="v.poster"
        [src]="v.video"
        preload="none"
        muted
        playsinline
        loop
        aria-hidden="true"
      ></video>
      <span class="vd-gb-play material-icons-outlined">play_arrow</span>
      <span class="vd-gb-duration">{{ (v.duration_sec / 60) | number: '1.0-0' }} min</span>
    </div>

    <div class="vd-gb-meta" [attr.dir]="guide.isRtl() ? 'rtl' : 'ltr'">
      <strong>{{ v.title }}</strong>
      <small>{{ 'guide.watch_hint' | transloco }}</small>
    </div>

    <button class="vd-gb-close" (click)="dismiss($event)"
            [attr.aria-label]="'guide.dismiss' | transloco">
      <span class="material-icons-outlined">close</span>
    </button>

    <button class="vd-gb-shrink" *ngIf="expanded()" (click)="collapse($event)"
            [attr.aria-label]="'guide.collapse' | transloco">
      <span class="material-icons-outlined">close_fullscreen</span>
    </button>
  </div>

  <vd-guide-modal
    *ngIf="modalOpen()"
    [guide]="guide.activeGuide()!"
    (closed)="onModalClosed($event)"
  ></vd-guide-modal>
</ng-container>
